import { useEffect, useState } from "react";

import { CallService } from "../../../services/call_service";
import { CallServices, CoreServices } from "../../../base/service/apiServices";
import { ChatActions } from "../../../store/slices/chat_slice/chat_slice";
import { ChatState } from "../../../base/models/model";
import { GetItemFromStorage } from "../../../custom_hooks/useStorage";
import { LocalStorage } from "../../../custom_hooks/localStorageKeys";
import { WtButton } from "../../../shared/widges/Button/button";
import _ from "lodash";
import callChatService from "../../../base/service/chatService";
import store from "../../../store/redux-store/root_store";
import styles from "./incomingChat.module.scss";
import { useDispatcher } from "../../../custom_hooks/use_app_dispatch";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import moment from "moment";
import axios from "axios";
import { notification } from "antd";
import { getPriviousChannelSummary } from "../utils";

function IncomingChatNotify() {
  const navigate = useNavigate();
  const dispatch = useDispatcher();
  const [over, setOver] = useState(false);
  const [[m, s], setTime] = useState<any>([0, 30]);
  const [queueName, setQueueName] = useState(null);
  const popUpDetails: any = useSelector((state: any) => state.callPopUpDetails);
  let { callSessionDetailswhilePopup } = popUpDetails;
  const [agentOccupyDetails, setAgentOccupyDetails] = useState(null);
  let { queueTrackerData } = useSelector((state: any) => state.queueTracker);
  let { acceptCallFunction, declineCallFunction } = CallService(dispatch, navigate);
  const roomData: any = store.getState().chatReducer;
  let { allIncomingSessionDetails } = roomData;
  const chatReducer: ChatState = useSelector((state: any) => state.chatReducer);
  let { internalSessionId, internalSessionDetailswhilePopup } = chatReducer;
  let { currentSession } = chatReducer;
  const userDetails = GetItemFromStorage(LocalStorage.USER_DETAILS);
  const LoginUserDetails: any = userDetails;
  const user_ext: any = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS)
  let startTime: any, timerInterval: any;
  let today = moment().format('YYYY-MM-DD');
  let startTimestampInSeconds = moment.utc(`${today} 00:00:00`, 'YYYY-MM-DD HH:mm:ss').valueOf();
  let todayStart = moment().format('YYYY-MM-DD');
  let toTimestampInSeconds = moment.utc(`${todayStart} 23:59:59`, 'YYYY-MM-DD HH:mm:ss').valueOf();
  const [disableAcceptChat, setDisableAcceptChat] = useState<any>(false);

  const acceptNotify = async () => {
    clearInterval(timerID);
    setDisableAcceptChat(true);
    let chatSessionData: any;
    await CallServices.get(`/get_chatSessionId/${roomData?.internalSessionDetailswhilePopup?.ChatHistoryId}`).then(async (response: any) => {
      //await axios.get(`http://localhost:5007/callservice/v1/get_chatSessionId/${roomData?.internalSessionDetailswhilePopup?.ChatHistoryId}`).then(async (response: any) => {
      console.log('IncomingChatNotify get_chatSessionId api --> ', response.data);
      if (response.data.statusCode === 200) {
        chatSessionData = response?.data?.result[0] ?? {};
        let chatHistoryDuration: any = response?.data?.result1 ?? {};
        const chatArrLength: any = response?.data?.result1.length - 1;
        chatSessionData.Number = roomData?.internalSessionDetailswhilePopup?.fromCallerNumber;
        chatSessionData.calledPersonDetails = roomData?.internalSessionDetailswhilePopup?.contactDetails;
        chatSessionData['dialDuration'] = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
        chatSessionData['queueId'] = roomData?.internalSessionDetailswhilePopup?.queueId
        console.log("chatSessionData2143135", response?.data?.result[0])
        let removeUserPayload = {
          sessionId: roomData?.internalSessionDetailswhilePopup?.sessionId.trim(),
          ChatHistoryId: roomData?.internalSessionDetailswhilePopup?.ChatHistoryId,
          removeQueueId: roomData?.internalSessionDetailswhilePopup?.queueSettingsId,
          domainId: LoginUserDetails?.domainId,
        }
        callChatService.removeChatQueueUser(removeUserPayload)
        if (response?.data?.result[0]?.CustomerId === 0) {
          let body = {
            domainId: response?.data?.result[0]?.domainId
          }
          await CoreServices.post(body, `/insert_update_customer_contact`)
            .then(async (response: any) => {
              console.log('IncomingChatNotify insert_update_customer_contact api --> ', response.data);
              if (response?.data.statusCode === 200) {
                chatSessionData.CustomerId = response?.data?.insertContactResult?.coid;
                let coidData = {
                  CustomerId: response?.data?.insertContactResult?.coid,
                  ChatHistoryId: chatSessionData?.ChatHistoryId
                }
                callChatService.storeCustomerCoid(coidData)
              }
              else {
                setDisableAcceptChat(false);
              }
            }).catch((err: any) => {
              console.log("err");
              setDisableAcceptChat(false);
            })
        } else {
          try {
            getPriviousChannelSummary(dispatch, {coid: response?.data?.result[0]?.CustomerId, currentSessionId: roomData?.internalSessionDetailswhilePopup?.sessionId?.trim()})
            // await CoreServices.get(`/get_customer_latest_msg/${response?.data?.result[0]?.CustomerId}`)
            //   .then(async (responsed: any) => {
            //     let messageData = JSON.parse(responsed?.data?.data[0][0].Message);
            //     if (messageData?.length > 0) {
            //       let body = {
            //         user_query: responsed?.data?.data[0][0].Message
            //       }
            //       axios.post('https://scraping.worktual.co.uk/previous_chat_summary', body).then(async (res: any) => {
            //         if (res?.data?.status_code === 200) {

            //           const timeFormat = await formatDate(responsed?.data?.data[0][0]?.lastModifiedDate)
            //           let payload = {
            //             message: res?.data?.message,
            //             sessionId: internalSessionDetailswhilePopup?.sessionId.trim(),
            //             ChatHistoryId: roomData?.internalSessionDetailswhilePopup?.ChatHistoryId,
            //             customerId: response?.data?.result[0]?.CustomerId,
            //             attend: responsed?.data?.data[0][0].Attendee,
            //             time: timeFormat
            //           }
            //           dispatch(ChatActions.setCustomerPreviousHistory(payload))
            //         }
            //         else {
            //           setDisableAcceptChat(false);
            //         }
            //       }).catch((err: any) => {
            //         setDisableAcceptChat(false);
            //         console.log("err");
            //       })
            //     }
            //   }).catch((err: any) => {
            //     setDisableAcceptChat(false);
            //     console.log("err");
            //   })
          } catch (err) {
            setDisableAcceptChat(false);
            console.log(err)
          }
        }
        const chatData: any = {
          agentExt: LoginUserDetails?.ext,
          agentName: LoginUserDetails?.profileName,
          domainId: LoginUserDetails?.domainId,
          ChatHistoryId: roomData?.internalSessionDetailswhilePopup?.ChatHistoryId,
          agentId: user_ext?.UserID,
          queueId: roomData?.internalSessionDetailswhilePopup?.queueId,
          agentSkillId: user_ext?.routing_profile_id,
          sourceChatDurationHistoryId: chatHistoryDuration[chatArrLength]?.ChatDurationHistoryId
        }
        if (roomData?.internalSessionDetailswhilePopup?.chatPlanId === 54 || roomData?.internalSessionDetailswhilePopup?.chatPlanId === 32) {
          console.log("roomData?.internalSessionDetailswhilePopup?.chatPlanId", roomData?.internalSessionDetailswhilePopup?.chatPlanId)
          chatData.ChatDurationHistoryId = roomData?.internalSessionDetailswhilePopup?.ChatDurationHistoryId
          chatData.sourceChatDurationHistoryId = 0
        }
        await CallServices.post(chatData, `/agent_connect_id_generate`).then(async (chatRes: any) => {
          console.log('IncomingChatNotify agent_connect_id_generate api --> ', chatRes.data);
          // axios.post(`http://localhost:5007/callservice/v1/agent_connect_id_generate`, chatData).then(async (chatRes: any) => {
          callChatService.io.emit("agentAcceptRequest", {
            message: "Agent accept the chat",
            agentExt: user_ext?.ext,
            agentName: user_ext?.UserName,
            domainId: user_ext?.domainId,
            ChatHistoryId: roomData?.internalSessionDetailswhilePopup?.ChatHistoryId,
            agentId: user_ext?.UserID,
            agentSkillId: user_ext?.routing_profile_id,
            to: internalSessionDetailswhilePopup.sessionId.trim(),
            transferType: roomData?.internalSessionDetailswhilePopup?.transferType,
            primaryAgent: roomData?.internalSessionDetailswhilePopup?.primaryAgent,
            agentChatDurationHistoryId: chatRes.data?.result[0][0]?.ChatDurationHistoryId
          });
          callChatService.io.emit('chatAcceptedDeviceType', {
            ChatHistoryId: roomData?.internalSessionDetailswhilePopup?.ChatHistoryId,
            to: `${user_ext?.domainId}_${user_ext?.ext}`,
            agentId: user_ext?.UserID,
            deviceType: 'Web'
          });
          chatSessionData.ChatDurationHistoryId = chatRes.data?.result[0][0]?.ChatDurationHistoryId;
          chatSessionData.showState = true;
          chatSessionData.queueId = roomData?.internalSessionDetailswhilePopup?.queueId ?? 0
          // chatSessionData.queueName = roomData?.internalSessionDetailswhilePopup?.queueName;
          console.log("chatSessionData", chatSessionData)
          dispatch(ChatActions.currentChatSession(chatSessionData));
          dispatch(ChatActions.chatSessionList(chatSessionData));
          dispatch(ChatActions.acceptChat(chatSessionData));
          // dispatch(ChatActions.storeCurrentSessionMsgHistory(message));

          const ringer: any = document.getElementById("ringer");
          ringer.pause();

          await CallServices.get(`/get_customer_history/${chatRes.data?.result[0][0]?.ChatDurationHistoryId}`).then((response: any) => {
            if (response.data.statusCode === 200) {
              console.log('IncomingChatNotify get_customer_history api --> ', response.data);
              let test = JSON.parse(response.data.customerValidateData[0][0].Message) ?? [];
              const firstMsgAgentAssist = test?.find((elem: any) => 
                elem?.userText &&
                elem?.userText?.message?.planId &&
                [54, 116, 76, 32].includes(elem?.userText?.message?.planId) &&
                !elem?.userText?.message?.agentIntro &&
                elem?.userText?.message?.isCustomer &&
                elem?.userText?.message?.messageType?.toLowerCase() === 'text'
              );
              
              const enrichedMsg = firstMsgAgentAssist
                ? { ...firstMsgAgentAssist?.userText?.message, to: `${LoginUserDetails?.domainId}_${LoginUserDetails?.ext}`,ChatHistoryId: firstMsgAgentAssist?.userText?.message?.ChatHistoryId.toString() }
                : null;
                if (enrichedMsg) {
                  callChatService.firstAssistMessage(enrichedMsg);
                }
              const messageText = response.data?.messageList;
              messageText?.map((list: any) => {

                if (list.hasOwnProperty("userText")) {
                  dispatch(ChatActions.agentWorkSpaceHistory({ agent_work_space_history: list.userText.message }));
                  dispatch(ChatActions.storeCurrentSessionMsgHistory(list.userText.message));
                }
                if (list.hasOwnProperty("agentText")) {
                  dispatch(ChatActions.agentWorkSpaceHistory({ agent_work_space_history: list.agentText.message }));
                  dispatch(ChatActions.storeCurrentSessionMsgHistory(list.agentText.message));
                }
              });
            }
            else {
              setDisableAcceptChat(false);
            }
          });
          const body: any = {
            ChatHistoryId: roomData?.internalSessionDetailswhilePopup?.ChatHistoryId,
            ChatDurationHistoryId: chatSessionData?.ChatDurationHistoryId,
            answeredDuration: 30 - s
          }
          callChatService.chatNotifyDialDuration(body)
          navigate("/chatscreenagent");
        }

        ).catch((err: any) => {
          setDisableAcceptChat(false);
          console.log("err", err);
        })
      } else {
        setDisableAcceptChat(false);
      }
    });

    let value: any;
    if (agentOccupyDetails === null) {
      value = {
        "agentOccupyDetails": JSON.stringify({
          currentChatCount: { [LoginUserDetails?.ext]: 1 }
        })
      };
    } else {
      const tempData: any = agentOccupyDetails;
      const existingCurrentChatCount = tempData["currentChatCount"][LoginUserDetails?.ext];
      tempData.currentChatCount = { ...tempData?.currentChatCount, [LoginUserDetails?.ext]: existingCurrentChatCount !== undefined ? existingCurrentChatCount + 1 : 1 };
      value = { "agentOccupyDetails": JSON.stringify(tempData) };
    }
    CoreServices.post(value, `/insert_update_concurrent_chat`).then((value: any) => {
      if (value?.data?.statusCode === 200) {
        console.log('success')
      } else {
        setDisableAcceptChat(false);
        console.log('failed');
      }
    });
    let acceptData = {
      // to: internalSessionId.trim(),
      // responseMessage: "chat is declined",
      to: roomData?.internalSessionDetailswhilePopup.sessionId?.trim(),
      ext: userDetails?.ext,
      domainId: userDetails?.domainId,
    };
    callChatService.io.emit("deleteChatSession", acceptData);
    navigate("/chatscreenagent");
  };

  const formatDate = (dateString: any) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${day}-${month}-${year} ${hours}:${minutes}`;
  }


  const declineNotify = () => {
    startTime = new Date().getTime();
    setOver(true);
    let declineData = {
      // to: internalSessionId.trim(),
      // responseMessage: "chat is declined",
      to: roomData?.internalSessionDetailswhilePopup?.sessionId?.trim(),
      ext: userDetails?.ext,
      domainId: userDetails?.domainId,
      declined: true
    };
    // callChatService.io.emit("queue_handling", declineData);
    // Check these 2 lines below

    if (roomData?.internalSessionDetailswhilePopup.transferType !== 1 && !roomData?.internalSessionDetailswhilePopup.queueSettingsId) {
      callChatService.io.emit("agentDeclineRequest", { message: "Chat is declined", to: roomData?.internalSessionDetailswhilePopup.sessionId?.trim(), ext: userDetails?.ext });
    }
    callChatService.io.emit("changeAttendChatStatus", { domainId: userDetails?.domainId, sessionId: roomData?.internalSessionDetailswhilePopup.sessionId?.trim(), ext: userDetails?.ext, queueId: roomData?.internalSessionDetailswhilePopup.queueSettingsId });
    callChatService.io.emit('chatDeclinedDeviceType', {
      ChatHistoryId: roomData?.internalSessionDetailswhilePopup?.ChatHistoryId,
      to: `${user_ext?.domainId}_${user_ext?.ext}`,
      agentId: user_ext?.UserID,
      deviceType: 'Web',
      isTransfer: roomData?.internalSessionDetailswhilePopup.transferType == 1 ? 1 : 0
    });
    const ringer: any = document.getElementById("ringer");
    ringer.pause();
    startTime = new Date().getTime();
    const body = {
      startTmpstmp: startTimestampInSeconds,
      endTmpstmp: toTimestampInSeconds,
      timeZone: "",
      ChatHistoryId: roomData?.internalSessionDetailswhilePopup?.ChatHistoryId,
      QueueId: roomData?.internalSessionDetailswhilePopup?.queueId ?? null,
      IsMissed: 1,
      IsBot: 0,
      domainId: LoginUserDetails?.domainId,
      AgentId: user_ext?.UserID,
      ext: userDetails?.ext
    }
    callChatService.agentMissedCallDashboard(body);
    dispatch(ChatActions.declineChat());
    // declineCallFunction(callSessionDetailswhilePopup.userAgent);
    // CallPopUpAgentActions.setWholeData({
    //   acceptCallRoom: false,
    //   callRoomInfo: "",
    //   callSessionId: "",
    //   callSessionDetailswhilePopup: "",
    //   isCallAccepted: false,
    // });
  };
  let timerID: any = null
  useEffect(() => {
    timerID = setInterval(() => tick(), 1000);
    return () => {
      clearInterval(timerID);
    };
  }, [m, s]);

  useEffect(() => {
    CoreServices.get(`/get_concurrent_chat`).then((value: any) => {
      if (value?.data?.statusCode === 200) {
        const tempData = value?.data?.getConcurrentChatDataRes[0]?.agentOccupyDetails;
        setAgentOccupyDetails(JSON.parse(tempData));
      }
      else if (value?.data?.statusCode !== 404) {
        notification.error({
          message: value?.data?.message || 'Unable to fetch Value',
          placement: "topRight",
          duration: 7,
          top: 70,
        });
      }
    });

    queueTrackerData?.map((list: any) => {
      if (list?.qid === roomData?.internalSessionDetailswhilePopup?.queueId) {
        setQueueName(list?.queueName)
      }
    })
  }, []);

  const tick = () => {
    console.log('agentDeclineRequest tick function');
    if (m === 0 && s === 0) {
      callChatService.io.emit('chatDeclinedDeviceType', {
        ChatHistoryId: roomData?.internalSessionDetailswhilePopup?.ChatHistoryId,
        to: `${user_ext?.domainId}_${user_ext?.ext}`,
        agentId: user_ext?.UserID,
        deviceType: 'Web',
        isTransfer: roomData?.internalSessionDetailswhilePopup.transferType == 1 ? 1 : 0
      });
      dispatch(ChatActions.declineChat());
      const ringer: any = document.getElementById("ringer");
      ringer.pause();
      clearInterval(timerID);

      let declineData = {
        to: roomData?.internalSessionDetailswhilePopup.sessionId?.trim(),
        responseMessage: "chat is declined",
        ext: userDetails?.ext,
        domainId: userDetails?.domainId,
        declined: true
      };
      callChatService.io.emit("changeAttendChatStatus", { domainId: userDetails?.domainId, sessionId: roomData?.internalSessionDetailswhilePopup.sessionId?.trim(), ext: userDetails?.ext, queueId: roomData?.internalSessionDetailswhilePopup.queueSettingsId });
      if (roomData?.internalSessionDetailswhilePopup.transferType !== 1 && !roomData?.internalSessionDetailswhilePopup.queueSettingsId) {
        console.log('agentDeclineRequest called');
        callChatService.agentDeclineRequest(declineData);
        // callChatService.io.emit("queue_handling", declineData);
      } else {
        callChatService.io.emit("agentNotAttendEmitter",
          {
            sessionId: roomData?.internalSessionDetailswhilePopup.sessionId,
            to: roomData?.internalSessionDetailswhilePopup?.primaryAgent,
            from: userDetails?.ext
          })
      }
      const body = {
        startTmpstmp: startTimestampInSeconds,
        endTmpstmp: toTimestampInSeconds,
        timeZone: "",
        ChatHistoryId: roomData?.internalSessionDetailswhilePopup?.ChatHistoryId,
        QueueId: roomData?.internalSessionDetailswhilePopup?.queueId ?? null,
        IsMissed: 1,
        IsBot: 0,
        domainId: LoginUserDetails?.domainId,
        AgentId: user_ext?.UserID,
        ext: userDetails?.ext
      }
      callChatService.agentMissedCallDashboard(body)
    } else {
      setTime([m, s - 1]);
    }
  };

  return (
    <>

      {/* <div className={styles.chatwindow}>
        <div className={styles.chattop}>
          <img src={mailb} />
          <h3>{!_.isEmpty(allIncomingSessionDetails) ? allIncomingSessionDetails.customerData : internalSessionDetailswhilePopup?.contactDetails?.firstName !== null && internalSessionDetailswhilePopup?.contactDetails?.firstName !== undefined && internalSessionDetailswhilePopup?.contactDetails?.firstName !== "" ? internalSessionDetailswhilePopup?.contactDetails?.firstName : "New Customer"}</h3>
          <p>{allIncomingSessionDetails.customerData}</p>
        </div>
        <div className={styles.chatcenter}>
          <h4>Customer Support UK</h4>
          <h5>Answer in{" "}<span className={styles.timecount}>{`${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`}</span></h5>
        </div>
        <div className={styles.chatbottom}>
          <WtButton className={`buttonGreen ${styles.declinebtn}`} onClick={declineNotify} name="Decline" />
          <WtButton className={`buttonGreen ${styles.acceptbtn}`} onClick={acceptNotify} name="Accept" />
        </div>
      </div> */}


      <div className={`${styles.callcontainartopsec}`}>
        <div className={styles.incomingTop}>
          <svg width="65" height="65" viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="64.8891" height="64.8891" rx="22.3056" fill="#3A3FE0" />
            <g clip-path="url(#clip0_3091_352612)">
              <g filter="url(#filter0_d_3091_352612)">
                <path d="M48.541 26.6787V26.6066C48.5056 25.4309 48.4882 23.9646 48.2428 22.5352C47.9977 21.0883 47.4719 19.5323 46.3151 18.3194C44.1774 16.0584 41.1281 15.8233 38.7797 15.7689C37.6756 15.7417 34.8324 15.7276 31.9892 15.7276C29.146 15.7276 26.3026 15.7417 25.1986 15.7689C22.8326 15.8235 19.7834 16.0584 17.6276 18.3194C16.4884 19.5323 15.9805 21.0882 15.7173 22.5352C15.4724 23.9646 15.4724 25.4669 15.4371 26.6603C15.4196 28.5059 15.4196 30.37 15.4371 32.2147C15.4547 33.3913 15.4724 34.9105 15.7173 36.3398C15.9628 37.7876 16.4884 39.3436 17.6453 40.5556C19.7834 42.8176 22.8324 43.0526 25.1807 43.1061C26.6353 43.1431 30.9991 43.1607 34.4862 43.1607L40.9527 48.0092C41.1847 48.1835 41.4612 48.2724 41.7401 48.2724C41.9246 48.2724 42.1101 48.2336 42.2846 48.1545C42.7226 47.9555 43.0207 47.5217 43.073 47.0332L43.5113 42.3826C44.0544 42.1836 44.5802 41.9311 45.0708 41.6047C45.5092 41.3152 45.9295 40.9895 46.3149 40.574C47.4717 39.362 47.9975 37.8061 48.2427 36.3582C48.488 34.9105 48.5055 33.409 48.5231 32.2331C48.5231 31.3828 48.5583 30.6233 48.5758 29.7547C48.5758 28.7231 48.541 27.7101 48.541 26.6787ZM25.2526 31.2985C24.1349 31.2985 23.2292 30.3823 23.2292 29.2539C23.2292 28.1238 24.1351 27.2085 25.2526 27.2085C26.3702 27.2085 27.2763 28.1238 27.2763 29.2539C27.2763 30.3823 26.3702 31.2985 25.2526 31.2985ZM31.9998 31.2985C30.8821 31.2985 29.9764 30.3823 29.9764 29.2539C29.9764 28.1238 30.8823 27.2085 31.9998 27.2085C33.1174 27.2085 34.0235 28.1238 34.0235 29.2539C34.0235 30.3823 33.1175 31.2985 31.9998 31.2985ZM38.747 31.2985C37.6293 31.2985 36.7234 30.3823 36.7234 29.2539C36.7234 28.1238 37.6293 27.2085 38.747 27.2085C39.8648 27.2085 40.7705 28.1238 40.7705 29.2539C40.7705 30.3823 39.8646 31.2985 38.747 31.2985Z" fill="white" />
              </g>
            </g>
          </svg>
          Incoming Chat...
        </div>
        <div className={styles.callwhisperinnercon}>
          <div className={styles.succesconsec}>
            {/* <div className={styles.userconsec}>
              <span>{!_.isEmpty(allIncomingSessionDetails) ? allIncomingSessionDetails.customerData :
                internalSessionDetailswhilePopup?.contactDetails?.firstName !== null && internalSessionDetailswhilePopup?.contactDetails?.firstName !== undefined &&
                  internalSessionDetailswhilePopup?.contactDetails?.firstName !== "" ? internalSessionDetailswhilePopup?.contactDetails?.firstName :
                  "New Customer"}</span>
              <label className={styles.phnenumber}>{allIncomingSessionDetails.customerData}</label>
            </div> */}
            {internalSessionDetailswhilePopup?.contactDetails?.firstName?.length > 20 ?
              <div className={`${styles.userconsec} ${styles.widthfull}`}>
                <div className={"marqueeWrapper"}>
                  <span className="marqueeEffect">{!_.isEmpty(allIncomingSessionDetails) ? allIncomingSessionDetails.customerData :
                    internalSessionDetailswhilePopup?.contactDetails?.firstName !== null && internalSessionDetailswhilePopup?.contactDetails?.firstName !== undefined &&
                      internalSessionDetailswhilePopup?.contactDetails?.firstName !== "" ? internalSessionDetailswhilePopup?.contactDetails?.firstName :
                      "New Customer"}</span>

                  <span className="marqueeEffect">{!_.isEmpty(allIncomingSessionDetails) ? allIncomingSessionDetails.customerData :
                    internalSessionDetailswhilePopup?.contactDetails?.firstName !== null && internalSessionDetailswhilePopup?.contactDetails?.firstName !== undefined &&
                      internalSessionDetailswhilePopup?.contactDetails?.firstName !== "" ? internalSessionDetailswhilePopup?.contactDetails?.firstName :
                      "New Customer"}</span>
                </div>
                <label className={styles.phnenumber}>{allIncomingSessionDetails.customerData}</label>
              </div>
              :
              <div className={styles.userconsec}>
                <span>{!_.isEmpty(allIncomingSessionDetails) ? allIncomingSessionDetails.customerData :
                  internalSessionDetailswhilePopup?.contactDetails?.firstName !== null && internalSessionDetailswhilePopup?.contactDetails?.firstName !== undefined &&
                    internalSessionDetailswhilePopup?.contactDetails?.firstName !== "" ? internalSessionDetailswhilePopup?.contactDetails?.firstName :
                    "New Customer"}</span>
                <label className={styles.phnenumber}>{allIncomingSessionDetails.customerData}</label>
              </div>
            }

            <div className={styles.supportconsec}>
              <span className={styles.curntsuprt}>{queueName ?? internalSessionDetailswhilePopup?.chatWidgetName}</span>
              <label className={styles.anstxt}>
                Answer in{" "}
                <span className={styles.timecount}>
                  <p>{`${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`}</p>
                </span>
              </label>
            </div>
            <div className={styles.acceptbtnconsec}>
              <WtButton className={`buttonGreen ${styles.declinebtn}`} onClick={declineNotify} onTouchStart={declineNotify} name="Decline Chat" />
              {!disableAcceptChat ? <WtButton className={`buttonGreen ${styles.acceptbtn}`} onTouchStart={acceptNotify} onClick={acceptNotify} name="Accept Chat" />
                : <WtButton className={`buttonGreen ${styles.acceptbtn}`} onClick={acceptNotify} onTouchStart={acceptNotify} disabled={true} name="Accept Chat" />}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default IncomingChatNotify;
